export const addFieldArrayObject = async (array, field, value) => {
    array.forEach(element => {
        element[field] = value
    });
}

export const filterArrayEqual = (array, field,  value) => {
        return array.filter(data => {
                    if (data[field] === value)
                        return true
                    else 
                        return false
                })
}
export const filterArrayMoreEqual = (array, field,  value) => {
    let arrResult = []
    for (let i = 0; i < value.length; i++) {
        for (let j = 0; j < array.length; j++) {
            if(value[i] === array[j][field]) {
                arrResult = [...arrResult, array[j]]
            }
        }
    }
    return arrResult
}

export const filterArrayLessEqual = (array, field,  value) => {
    let result = array
    for (let index = 0; index < value.length; index++) {
        result = result.filter(data => {
            if (data[field] !== value[index])
                return true
            else 
                return false
        })
    }
    return result
}

export const filterArrayNotEqual = (array, field,  value) => {
    return array.filter(data => {
                if (data[field] !== value)
                    return true
                else 
                    return false
            })
}

export const filterArrayNotEqualAccountJoint = (array, field,  value) => {
    return array.filter(data => {
                if ((data[field] !== value) && (data["TipoFirma"]  !== "CONJUNTA"))
                    return true
                else 
                    return false
            })
}

export const isEmpty = (obj) => {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

export const arrayhierarchy = (array, hierachy, key) => {
    // console.log(array, hierachy)
    let arrResult = []
    for (let i = 0; i < hierachy.length; i++) {
        for (let j = 0; j < array.length; j++) {
            if(hierachy[i] === array[j][key]) {
                arrResult = [...arrResult, array[j]]
            }
        }
    }

    return arrResult;
}